module.exports = __webpack_public_path__ + "img/ssa3.b4224958.jpg";